import { graphql } from 'gatsby';
import { RichTextElement } from '@kontent-ai/gatsby-components';
import { QuoteWrapper, QuoteText, QuoteAuthor, QuoteLogo } from './Quote.styles';
import { isRichTextValid } from '../../utils';
import useResolveRichTextInternalLink from '../../hooks/useResolveRichTextInternalLink';

const Quote = ({ quoteElements: elements }: Queries.QUOTEFragment) => {
  const { quote, author, role, logo } = elements;
  const hasLogo = logo?.value?.url && logo.value.url.length > 0;
  const hasRole = role?.value && role.value.length > 0;
  const resolveRichTextInternalLink = useResolveRichTextInternalLink();

  return (
    <QuoteWrapper>
      <QuoteText>
        {isRichTextValid(quote.value) && (
          <RichTextElement {...quote} resolveLink={resolveRichTextInternalLink} />
        )}
      </QuoteText>
      <QuoteAuthor>
        {author?.value && (
          <span>
            {author.value}
            {hasRole && `, ${role.value}`}
          </span>
        )}
        {hasLogo && <QuoteLogo src={logo.value.url} alt={logo.value.description ?? 'quote logo'} />}
      </QuoteAuthor>
    </QuoteWrapper>
  );
};

export default Quote;

export const fragments = graphql`
  fragment QUOTE on kontent_item_quote {
    __typename
    system {
      id
      codename
    }
    quoteElements: elements {
      quote {
        value
        links {
          codename
          link_id
        }
      }
      author {
        value
      }
      role {
        value
      }
      logo {
        value {
          url
          description
        }
      }
    }
  }
`;
